import React from 'react';
import { Field, FastField, FieldConfig, FieldProps } from 'formik';

import { useRegisteredRef } from 'src/lib/react-register-nodes';
import { ErrorMessage, Input, InputProps } from 'src/kit';
import { FormikErrorMessage } from './FormikErrorMessage';

export type FormikInputProps = InputProps &
  FieldConfig & {
    isFast?: boolean;
    externalError?: boolean;
  };

export const FormikInput = ({ isFast, name, validate, externalError, ...rest }: any) => {
  const FieldComponent = isFast ? FastField : Field;
  const ref = useRegisteredRef(name);

  return (
    <FieldComponent name={name} validate={validate}>
      {({ field, meta: { error, touched } }: FieldProps) => {
        const internalError = touched && error;
        const inputError = externalError || internalError;
        return (
          <Input {...field} ref={inputError ? ref : undefined} error={inputError} {...rest}>
            {!externalError && <FormikErrorMessage name={name} />}
            {typeof externalError === 'string' && <ErrorMessage>{externalError}</ErrorMessage>}
          </Input>
        );
      }}
    </FieldComponent>
  );
};
